import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserManagementService } from '../user-management/user-management.service';

export interface NavbarActionContext {
  router: Router;
  userService: UserManagementService;
  clearFilterSelections?: () => void;
  allocatedSite?: string | number | null;
  user?: any;
  http?: HttpClient;
  modalService?: NgbModal;
  siteEditStatusDialog?: any;
}

export async function executeNavbarAction(
  actionId: string,
  context: NavbarActionContext
): Promise<void> {
  switch (actionId) {
    case 'logout':
      handleLogout(context);
      return;
    case 'dms':
      sessionStorage.setItem('dmsRedirectUrl', '/site/dms');
      await context.router.navigate(['/site/dms-user-setting']);
      return;
    case 'dmsUserSetting':
      sessionStorage.removeItem('dmsRedirectUrl');
      await context.router.navigate(['/site/dms-user-setting']);
      return;
    case 'purifaiUserSetting':
      sessionStorage.removeItem('dmsRedirectUrl');
      await context.router.navigate(['/site/purifai-user-setting']);
      return;
    case 'plantCustomization':
      await handlePlantCustomization(context);
      return;
    case 'myDataPrivacy':
      await context.router.navigate(['/account/privacy']);
      return;
    case 'auditLogs':
      await context.router.navigate(['/account/audit-logs']);
      return;
    default:
      return;
  }
}

function handleLogout(context: NavbarActionContext): void {
  context.clearFilterSelections?.();
  context.userService.logout();
  sessionStorage.removeItem('visitedUserManagementSites');
  sessionStorage.removeItem('admin_id');
}

async function handlePlantCustomization(context: NavbarActionContext): Promise<void> {
  const userId = context.user?.id || context.user?.user_id || null;
  const siteId = context.allocatedSite;

  if (!(siteId && userId && context.http)) {
    return;
  }

  const payload = {
    site_id: siteId,
    user_id: userId,
    site_edit_status: true,
  };

  try {
    const response: any = await firstValueFrom(
      context.http.post(`${environment.nodeUrl1}site/updateEditCheck`, payload)
    );
    const siteEditStatus = response?.data?.site_edit_status;

    if (siteEditStatus === 0) {
      await context.router.navigate(['/site-setting']);
      return;
    }

    if (siteEditStatus === 1 && context.modalService && context.siteEditStatusDialog) {
      context.modalService.open(context.siteEditStatusDialog, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        backdropClass: 'site-edit-status-backdrop',
        windowClass: 'site-edit-status-modal-window',
      });
    }
  } catch (error) {
    console.error('Error checking site edit status:', error);
  }
}
